import React from 'react';

const HomeIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">home</span>
            </>
      );
};

export default HomeIcon;
